import DiscontinuedReferences from 'pages/BackOfficePage/BackOfficeCategories/DiscontinuedReferences/DiscontinuedReferences';

export default DiscontinuedReferences;
